import { render, staticRenderFns } from "./AdminDetail.vue?vue&type=template&id=71f292fe&scoped=true&"
import script from "./AdminDetail.vue?vue&type=script&lang=js&"
export * from "./AdminDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f292fe",
  null
  
)

export default component.exports